export default {
  "pages.one": "{{count}} page",
  "pages.other": "{{count}} pages",
  "slides.one": "{{count}} slide",
  "slides.other": "{{count}} slides",
  "sheets.one": "{{count}} sheet",
  "sheets.other": "{{count}} sheets",
  page: "Page {{number}}",
  slide: "Slide {{number}}",
  hiddenSlide: "Hidden slide",
  slideFailed: "This slide could not be shown",
  speakerNotes: "Speaker notes",
  "sheet.copyTooLarge": "The selection is too large to copy",
  "sheet.copyFailed": "The cells could not be copied",
  "sheet.openFailed": "This sheet could not be opened",
  "sheet.paintFailed": "This part of the sheet could not be shown",
  "sheet.tabs": "Sheets",
  "problem.compound": "This file is password-protected or saved in an older Office format.",
  "problem.format": "This file is not a valid Office document.",
}
